import React, { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography'

import undrawImg from 'static/images/undraw-having-fun-iais.png'
import awardsImg from 'static/images/undraw-awards-fieb.svg'
import wineTastingImg from 'static/images/undraw-wine-tasting-30-vw.svg'
import boxWineImg from 'static/images/undraw-logistics-x-4-dc.svg'
import goup12Img from 'static/images/group-12.svg';

/*
  1501: 欲出窖的藏酒含有箱入藏酒
  1502: 欲出窖的藏酒超過 24 瓶
  1503: 尚有未付款的儲存費
*/

const EmptyStorage = props => {
	const { t } = useTranslation();
	const { type } = props
	const renderContent = () => {
		switch (type) {
			case 'create-shipping-order-1501':
			case 'create-shipping-order-1502':
				return (
					<>
						<img
							alt=""
							src={boxWineImg}
							height="274"
							width="378"
							style={{ margin: '40px 0' }}
						/>
						<Typography variant="h2" style={{ marginBottom: '25px' }}>
							本次托運車含箱入愛酒，請聯繫客服。
						</Typography>
					</>
				)
			case 'create-shipping-order-1503':
				return (
					<>
						<img
							alt=""
							src={goup12Img}
							height="274"
							width="378"
							style={{ margin: '40px 0' }}
						/>
						<Typography variant="h2" style={{ marginBottom: '25px' }}>
							您尚有儲存費用未繳納，須先進行繳納後才能進行托運出窖唷！
						</Typography>
					</>
				)
			case 'cart':
				return (
					<Fragment>
						<Typography variant="h2">在藏酒列表中將愛酒加入托運車並完成付款，</Typography>
						<Typography variant="h2">即可在指定的時段內收到您的愛酒！</Typography>
						<img
							alt=""
							src={wineTastingImg}
							height="274"
							width="378"
							style={{ margin: '40px 0' }}
						/>
						<Typography variant="h2" style={{ marginBottom: '25px' }}>
							看來您的托運車內還沒有任何酒唷！
						</Typography>
					</Fragment>
				)
			case 'wine-list':
				return (
					<Fragment>
						<Typography variant="h2">完成影像辨識及資料比對後，您寄達的酒將會顯示在此，</Typography>
						<Typography variant="h2">您可以在這裡看到每一瓶酒的國際市價，也可以在此撰寫自己的品飲筆記。</Typography>
						<img
							alt=""
							src={awardsImg}
							height="284"
							width="432"
							style={{ margin: '40px 0' }}
						/>
						<Typography variant="h2" style={{ marginBottom: '25px' }}>
							已經將愛酒寄出了嗎？點擊查看愛酒是否已送達。
						</Typography>
					</Fragment>
				)
			case 'inbound-list':
			default:
				return (
					<Fragment>
						<Typography variant="h2">我們會將您打算存入酒窖的酒拍照紀錄，</Typography>
						<Typography variant="h2">您可以在此頁面確認這些相片與您寄達的酒是否相符。</Typography>
						<img
							alt=""
							src={undrawImg}
							height="275"
							width="437"
							style={{ margin: '40px 0' }}
						/>
						<Typography variant="h2" style={{ marginBottom: '25px' }}>
							看來您還沒有任何酒寄達唷！
						</Typography>
					</Fragment>
				)
		}
	}

	const buttonCont = () => {
		switch (type) {
			case 'create-shipping-order-1501':
			case 'create-shipping-order-1502':
				return '返回托運車'
			case 'cart':
				return t('storage_winelist')
			case 'wine-list':
				return t('inbound_detail')
			case 'inbound-list':
			case 'create-shipping-order-1503':
			default:
				return t('shipping_wine')
		}
	}

	return (
		<Grid container alignItems="center" justify="center"
			className="main-contaienr empty-page"
		>
			<Grid item xs={8}
				container alignItems="center" justify="center" direction="column"
				className="bg-white"
			>
				{renderContent()}
				<Button color="primary" variant="contained"
					onClick={props.onClick}
				>
					{buttonCont()}
				</Button>
			</Grid>
		</Grid>
	)
}

export default EmptyStorage
